import { render, staticRenderFns } from "./BrandsView.vue?vue&type=template&id=7fa23e32"
import script from "./BrandsView.vue?vue&type=script&lang=ts"
export * from "./BrandsView.vue?vue&type=script&lang=ts"
import style0 from "./BrandsView.vue?vue&type=style&index=0&id=7fa23e32&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports